import { VyFormSection, VyIcon } from '@vy/ui-design-system';
import { useWatch } from 'react-hook-form';
import { FieldGrid } from '../../modify-panel-shared/layout';
import { useChargeContext } from '../../charge-context';
import { VySwitchField } from '../../../../../../design-system-adapters/forms';
import { CadenceBillingIntervalInputs, CalendarAlignmentSwitch } from '../../modify-panel-shared/selectors';
import { FixedChargeDatePicker, OneTimeChargeDateRangePicker } from '../selectors';
import type { PlanInputForm } from '../../CreatePlanForm/create-plan-form-types/plan-input-form';

export type ScheduleSectionProps = {
  showCadence?: boolean;
  showCalendarAlign?: boolean;
  showContractUpfront?: boolean;
  showFixedStartDate?: boolean;
  showOneTimeDateRange?: boolean;
};

export function ScheduleSection({
  showCadence = false,
  showCalendarAlign = false,
  showContractUpfront = false,
  showFixedStartDate = false,
  showOneTimeDateRange = false,
}: ScheduleSectionProps) {
  const { itemIndex: productIndex } = useChargeContext();

  const contractUpfrontPath =
    `fixedProducts.${productIndex}.variants.0.pricing.priceConfiguration.upfrontPay` as const;
  const isContractUpfrontEnabled = useWatch({ name: contractUpfrontPath });

  return (
    <VyFormSection icon={<VyIcon icon="SectionSchedule" width={20} height={20} />} title="Schedule">
      <FieldGrid>
        {showCadence && (
          <CadenceBillingIntervalInputs
            fieldNamePrefix="fixedProducts"
            productIndex={productIndex}
            disabled={Boolean(isContractUpfrontEnabled)}
          />
        )}
        {showCalendarAlign && (
          <CalendarAlignmentSwitch fieldNamePrefix="fixedProducts" productIndex={productIndex} />
        )}
        {showContractUpfront && (
          <VySwitchField<PlanInputForm>
            name={contractUpfrontPath}
            title="Contract upfront"
            description="Charge the full amount in advance on plan start date"
            data-field-span="full"
            data-vy="plan-charge-drawer-contract-upfront-switch"
          />
        )}
        {showFixedStartDate && <FixedChargeDatePicker variant="start" productIndex={productIndex} />}
        {showOneTimeDateRange && <OneTimeChargeDateRangePicker productIndex={productIndex} />}
      </FieldGrid>
    </VyFormSection>
  );
}
